import React from "react"
import FormCheckbox from "../lib/FormCheckbox"
import { InstrumentAlarmEvent } from '../Resources'

const InstrumentAlarmModalNotes = ({formState, setFormState}) => {
  const handleChange = (ev) => {
    const name = ev.target.name
    const value = ev.target.checked
    const causes = [...(formState.noteRequiredCauses ?? [])]
    if (value && !causes.includes(name)) {
      causes.push(name)
    } else if (!value && causes.includes(name)) {
      const index = causes.indexOf(name)
      causes.splice(index, 1)
    }
    setFormState({...formState, noteRequiredCauses: causes})
  }

  return (
    <>
      <p>
        <strong>Require user note for selected alarm events:</strong>
      </p>
      {InstrumentAlarmEvent.causes.map(cause => (
        <FormCheckbox
          key={cause}
          name={cause}
          label={InstrumentAlarmEvent.causeToHuman(cause)}
          checked={(formState.noteRequiredCauses ?? []).includes(cause)}
          onChange={handleChange}
        />
      ))}
    </>
  )
}

export default InstrumentAlarmModalNotes
